import { useState, useCallback } from "react";

export const useAuth = () => {
	const [user, setUser] = useState({ userId: null, loggedInRedirectUrl: "" });

	const login = useCallback((userData) => {
		setUser(userData);
	}, []);

	return { user, login };
};
